import { render, staticRenderFns } from "./StudyHeroList2.vue?vue&type=template&id=6514f5fe&scoped=true&"
import script from "./StudyHeroList2.vue?vue&type=script&lang=js&"
export * from "./StudyHeroList2.vue?vue&type=script&lang=js&"
import style0 from "./StudyHeroList2.vue?vue&type=style&index=0&id=6514f5fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6514f5fe",
  null
  
)

export default component.exports